/*
 * @Descripttion: your project
 * @version: 1.0
 * @Author: zouyuping
 * @Date: 2022-04-20 15:17:59
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-05-24 17:13:03
 */
import { requestOfGet, requestOfPost } from "../utils/http";
const baseUrl = "wechath5/zh-cn/v1/";
export function getDiningRoomList(param) {
  return requestOfGet(`${baseUrl}meal/getdiningroomquery`, param);
}
// 点餐餐品信息列表
export function getFoodList(param) {
  return requestOfGet(`${baseUrl}meal/list/${param.code}`, param);
}
export function getSetmealFoodInfo(param) {
  return requestOfGet(
    `${baseUrl}meal/${param.vpnId}/packagemeal/${param.goodsId}`,
    param
  );
}

export function submitFoodOrder(param) {
  return requestOfPost(`${baseUrl}meal/saveorder`, param);
}
export function getPayedHistoryOrderList(param) {
  return requestOfGet(`${baseUrl}meal/orderlist`, param);
}
export function payByhandkey(param) {
  return requestOfPost(`${baseUrl}meal/pay/handkey`, param);
}
